export default function() {
  const widgetName = 'cardWidgetFour';
  const widgetOpts = cardWidgetFourOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      let delay = 0;
      if (data.items.length === 0) {
        $('.tier-three').remove();
      } else { 
        $(`#${widgetName} .card-widget-item`).each(function() {
          $(this).attr({
            'data-aos': 'zoom-in-up',
            'data-aos-offset': '50',
            'data-aos-delay': `${delay}`
          });
          delay += 50;
        });
        $(`#${widgetName} .buttonwrap a`).addClass('button');
        $(`#${widgetName}`).find('.saffire-card-widget-buy-now a, .saffire-card-widget-more a').removeAttr('target');
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [null], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'LEARN MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}